import { Group, Pill } from '@mantine/core'
import { FormattedMessage } from 'react-intl'
import { AppFilter } from './AppFilter'
import { CameraFilter } from './CameraFilter'
import { DeviceFilter } from './DeviceFilter'

export type DeploymentListFilterConfig = {
  application_id?: string
  device_id?: string
  stream_id?: string
  group_id?: string
}

type DeploymentListFilterProps = {
  filterConfig: DeploymentListFilterConfig
  onFilterChange: (filterConfig: DeploymentListFilterConfig) => void
}

export const DeploymentListFilter = ({
  filterConfig,
  onFilterChange
}: DeploymentListFilterProps) => {
  const handleFilterChange = (
    filterKey: keyof DeploymentListFilterConfig,
    value: string | null
  ) => {
    onFilterChange({ ...filterConfig, [filterKey]: value || '' })
  }

  return (
    <Group gap="xs">
      <AppFilter
        value={filterConfig.application_id || null}
        onChange={(value) => handleFilterChange('application_id', value)}
      />

      <CameraFilter
        value={filterConfig.stream_id || null}
        onChange={(value) => handleFilterChange('stream_id', value)}
      />

      <DeviceFilter
        value={filterConfig.device_id || null}
        onChange={(value) => handleFilterChange('device_id', value)}
      />

      {filterConfig.group_id && (
        <Pill
          size="md"
          withRemoveButton
          onRemove={() => handleFilterChange('group_id', null)}
        >
          <FormattedMessage
            id="deployments.list.filter.group"
            values={{ id: filterConfig.group_id.slice(0, 8) }}
          />
        </Pill>
      )}
    </Group>
  )
}
